module.exports = __webpack_public_path__ + "img/banner-ai.7020b9e3.png";